import { COUNTRY_CODE, COUNTRY_CODE_CURRENCIES, COUNTRY_CODE_LOCALES, DEFAULT_COUNTRY_CODE, TAX_PERCENTAGES } from "@dw/constants/intl";

export const formatCurrency = (amount: number, countryCode?: COUNTRY_CODE): string => {
  const currencyFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode ?? DEFAULT_COUNTRY_CODE], {
    style: 'currency',
    currency: COUNTRY_CODE_CURRENCIES[countryCode ?? DEFAULT_COUNTRY_CODE]
  });
  return currencyFormatter.format(amount ?? 0);
}

export const formatNumber = (amount: number, countryCode?: COUNTRY_CODE): string => {
  const numberFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode ?? DEFAULT_COUNTRY_CODE]);
  return numberFormatter.format(amount);
}

export const formatPercentage = (amount: number, countryCode?: COUNTRY_CODE, decimalPoints: number = 0): string => {
  const percentageFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode ?? DEFAULT_COUNTRY_CODE], {
    style: 'percent',
    minimumFractionDigits: 0, // Adjust as needed
    maximumFractionDigits: decimalPoints, // Adjust as needed
  });
  return percentageFormatter.format(amount);
}

export const roundCurrency = (amount: number): number => Number(amount.toFixed(2));

export const calculatePostTaxAmount = (amount: number, countryCode?: COUNTRY_CODE): number => {
  const multiplier = TAX_PERCENTAGES[countryCode ?? DEFAULT_COUNTRY_CODE] + 1;
  return roundCurrency(amount * multiplier);
}

export const calculatePreTaxAmount = (amount: number, countryCode?: COUNTRY_CODE): number => {
  const multiplier = TAX_PERCENTAGES[countryCode ?? DEFAULT_COUNTRY_CODE] + 1;
  return roundCurrency(amount / multiplier);
}

/** Human-friendly file size for an attachment (bytes → "820kb" / "3.4mb"). */
export const formatFileSize = (bytes: number): string => {
  const sizeInKb = Math.ceil(bytes / 1024);
  return sizeInKb >= 1024 ? `${Math.ceil((sizeInKb / 1024) * 10) / 10}mb` : `${sizeInKb}kb`;
}